import { ScopedCssBaseline, ThemeProvider } from "@mui/material";
import React, { useEffect } from "react";
import { I18nextProvider } from "react-i18next";

import { MortgageContextProvider } from "../contexts/mortgage/MortgageContextProvider";
import { StepContextProvider } from "../contexts/steps/StepContextProvider";
import { useEventService } from "../services/event-service/EventServiceContext";
import i18n from "../translations/i18n";
import ContentContainer from "./ContentContainer";
import createLukbMuiTheme from "./theme/LukbMuiTheme";

/**
 * Parent and the first react component being rendered.
 */
const MortgageExtension = (props: { locale: string; customElement: HTMLElement; shadowRoot: HTMLElement }) => {
    const { locale, shadowRoot, customElement } = props;
    const eventService = useEventService();

    useEffect(() => {
        i18n.changeLanguage(locale);
    }, [locale]);

    useEffect(() => {
        eventService.setTriggerElement(customElement);
    }, []);

    return (
        <ThemeProvider theme={createLukbMuiTheme(shadowRoot)}>
            <I18nextProvider i18n={i18n}>
                <StepContextProvider>
                    <MortgageContextProvider>
                        <ScopedCssBaseline>
                            <ContentContainer />
                        </ScopedCssBaseline>
                    </MortgageContextProvider>
                </StepContextProvider>
            </I18nextProvider>
        </ThemeProvider>
    );
};
export default MortgageExtension;
